import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cart-checkout__notes"
};
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    return (_ctx.schema?.messages)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema?.messages, (message) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(['alert d-flex align-items-center pt-2 pb-2', message.style ? 'alert-' + message.style : 'alert-warning']),
                    role: "alert"
                }, [
                    (message.iconUrl)
                        ? (_openBlock(), _createBlock(_component_g_icon, {
                            key: 0,
                            class: "flex-shrink-0 me-2",
                            width: "24",
                            height: "24",
                            src: message.iconUrl,
                            "aria-label": "Warning:"
                        }, null, 8, ["src"]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        innerHTML: message.description
                    }, null, 8, _hoisted_2)
                ], 2));
            }), 256))
        ]))
        : _createCommentVNode("", true);
}
